<template>
  <div>
    <div class="row">
      <div class="col-6">
        <p><strong>{{ $t('Total projects') }}</strong></p>
      </div>
      <div class="col-6">
        <p>{{ total }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <p><strong>{{ $t('total capital cost' + budgetType) }}</strong></p>
      </div>
      <div class="col-6">
        <p>{{ total_capital_cost | formatMoney }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <p><strong>{{ $t('Total amount funded' + budgetType) }}</strong></p>
      </div>
      <div class="col-6">
        <p>{{ total_amount_funded | formatMoney }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <p><strong>{{ $t('Total amount unfunded' + budgetType) }}</strong></p>
      </div>
      <div class="col-6">
        <p>{{ total_amount_unfunded |formatMoney }}</p>
      </div>
    </div>
</div>
</template>

<script>

export default {
  props:['chartRecords', 'budgetType'],
  computed: {
    total_capital_cost() {
      return this.chartRecords.reduce((total,val) => {
        return total + parseFloat(val.capital_cost);
      },0);
    },

    total_amount_funded() {
      return this.chartRecords.reduce((total,val) => {
        return total + parseFloat(val.funded_amount);
      },0);
    },

    total() {
      return this.chartRecords.reduce((total,val) => {
        return total + parseInt(val.count);
      },0);
    },

    total_amount_unfunded() {
      return this.chartRecords.reduce((total,val) => {
        return total + parseFloat(val.unfunded_amount);
      },0);
    }
  }
}
</script>
